import { useDispatch } from 'react-redux';
import { useOrderQuery, useCancelOrderMutation, CheckoutOrderFragment } from '@websky/graphql';
import { fillOrder } from '../../../../Checkout/store/order/actions';

export function useCancelOrder() {
	const dispatch = useDispatch();

	const { refetch: getOrder } = useOrderQuery({ skip: true });
	const [cancelOrder, cancelOrderResult] = useCancelOrderMutation();

	const onCancelOrder = async ({ id }: { id: string }) => {
		let order: CheckoutOrderFragment;

		try {
			const { data } = await cancelOrder({ variables: { id } });

			if (data?.CancelOrder) {
				order = data.CancelOrder;
			}
		} catch {
			const { data } = await getOrder({ id });

			if (data.Order) {
				order = data.Order;
			}
		} finally {
			dispatch(fillOrder(order));
		}
	};

	return { onCancelOrder, cancelOrderResult };
}
